

<div *ngIf="muestraDetalle" class="container bg-white mb-4 mt-4 cornerr">
    <div class="row">
        
        <div class="col-12 col-lg-12">
          
            <article>
              
             
               
                <div class="row">
                    <div class="d-none d-md-block col-md-2"></div>
                    <div class="col-12 col-md-8">
                        <div class="mb-4">
                   
                            <h2 class="mb-1 mt-5 fuenteTitulo">{{titulo}}</h2>
                           
                            <div class="text-muted fst-italic mb-2">{{fecha2}}</div>
                           
                           
                        </div>
                        <figure class="mb-4"><img class="img-fluid rounded" src="{{archivo}}" alt="..." /></figure>
                        <section class="mb-5">
                            <p (keydown)="onKeydownEvent()" class="fs-6 mb-4" style="-webkit-user-modify: read-write-plaintext-only;">
                                    {{descripcion}}
                            </p>
                        </section>
                    </div>
                    <div class="d-none d-md-block col-md-2"></div>
                </div>
              
                  
               
               
               
            </article>
         
        </div>
       
      
    </div>
</div>

<div class="container-lg container-xl bg-white  my-5 py-5 cornerr" >

    <div  id="glit" class="container">
        <h1  class="imgBW">Noticias</h1>
        <div  id="line"></div>
    </div>
    
    <div class="row">
        <div class="col-12 col-sm-6 col-md-4" *ngFor="let item of noticias">
            <div class="card mb-1 mt-0" >
                <img src="{{item.archivo}}" style="object-fit: cover;height: 300px;" class="card-img-top img-fluid img-thumbnail" alt="...">
                <div class="card-body">
                  <h5 class="card-title fuenteSubtitulo cursor" (click)="irNoticia(item)">{{item.titulo}}</h5>
                  <p class="card-text module line-clamp"  >{{item.descripcion}}</p>
                  <p class="card-text"><small class="text-muted">{{item.fecha2}}</small></p>
                </div>
              </div>
        </div>
      
    
    </div>
  
    
        </div>
    